import styled from "styled-components";

const AvatarContainer = styled.div`
  display: flex;
  flex-direction: "row";
`;

export default AvatarContainer;
